function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React, { useContext, useMemo } from "react";
import cx from "classnames";
import { useUIDSeed } from "react-uid";
import { Body, CallToAction, Heading, Subheading } from "../../atoms";
import { ArrowRight } from "../../icons";
import { twMerge } from "../../../utils";
import { ImageContext } from "../../../context";
import { Section } from "../../molecules";
export var ImageAndContent = function(param) {
    var label = param.label, title = param.title, content = param.content, image = param.image, _imagePlacement = param.imagePlacement, imagePlacement = _imagePlacement === void 0 ? "left" : _imagePlacement, _accent = param.accent, accent = _accent === void 0 ? "none" : _accent, callToActions = param.callToActions, className = param.className, enableLines = param.enableLines, darkbackground = param.darkbackground, headlinevariant = param.headlinevariant;
    var seed = useUIDSeed();
    var ImageComponent = useContext(ImageContext).ImageComponent;
    var imageAspectRatio = useMemo(function() {
        return image.width / image.height;
    }, [
        image
    ]);
    var bgColor = darkbackground ? "offdefault" : "default";
    var hVariant = headlinevariant || "h3";
    var padding = useMemo(function() {
        var ratioRemainder = imageAspectRatio - 1;
        var factor = imageAspectRatio + Math.pow(ratioRemainder, 2);
        return Math.round(24 / factor);
    }, [
        imageAspectRatio
    ]);
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        className: className,
        backgroundColor: bgColor
    }, /*#__PURE__*/ React.createElement("div", {
        className: cx("relative grid gap-6 grid-cols-1 md:gap-10", imagePlacement === "left" && "md:grid-cols-[2fr_1fr]", imagePlacement === "right" && "md:grid-cols-[1fr_2fr]")
    }, /*#__PURE__*/ React.createElement("div", null, !!label && /*#__PURE__*/ React.createElement(Subheading, {
        className: "mb-5"
    }, label), !!title && /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: hVariant,
        className: "mb-7"
    }, title), /*#__PURE__*/ React.createElement(Body, {
        className: "prose md:prose-md"
    }, content), !!(callToActions === null || callToActions === void 0 ? void 0 : callToActions.length) && /*#__PURE__*/ React.createElement("div", {
        className: "mt-7"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col justify-center items-start -my-2 -mx-3"
    }, callToActions.map(function(action) {
        return /*#__PURE__*/ React.createElement(CallToAction, _extends({
            key: seed(action),
            icon: /*#__PURE__*/ React.createElement(ArrowRight, null),
            className: "mx-3 my-2"
        }, action));
    })))), /*#__PURE__*/ React.createElement("div", {
        className: cx("grid grid-cols-1 items-center", imagePlacement === "left" && "md:-order-1")
    }, accent !== "none" && /*#__PURE__*/ React.createElement("div", {
        role: "presentation",
        className: twMerge(cx("row-start-1 col-start-1 rounded-full bg-bg-inverted w-[86%] pb-[86%]", accent === "light" && "bg-bg-offdefault", imagePlacement === "left" && "mr-auto", imagePlacement === "right" && "ml-auto"))
    }), /*#__PURE__*/ React.createElement("div", {
        className: "row-start-1 col-start-1",
        style: {
            paddingRight: accent !== "none" && imagePlacement === "right" ? "".concat(padding, "%") : "",
            paddingLeft: accent !== "none" && imagePlacement === "left" ? "".concat(padding, "%") : ""
        }
    }, /*#__PURE__*/ React.createElement(ImageComponent, _extends({}, image))))));
};

//# sourceMappingURL=ImageAndContent.js.map